import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_BASE_URL;

if (!SOCKET_URL) {
  console.error("REACT_APP_BASE_URL is not defined in .env file");
}

export const socket = io(SOCKET_URL, {
  transports: ["websocket", "polling"],
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 5,
  withCredentials: true,
});